import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("button", {
    class: _normalizeClass(["px-4 py-2 rounded-lg bg-primary-600 transition-all text-white font-bold mx-auto", [
      _ctx.itsDisabled ? 'disabled:bg-primary/60' : 'hover:brightness-110',
      _ctx.uppercase ? 'uppercase' : '',
    ]]),
    disabled: _ctx.itsDisabled
  }, _toDisplayString(_ctx.text), 11, _hoisted_1))
}